function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
var first_scroll = true;
var first_anmation = true;

function secondaryImageMobile(imageSections){
  imageSections.forEach(section => {
    if(section.querySelector('.product-card--show-secondary-media')){
      let number_seconds = parseInt(section.querySelector('.product-card--show-secondary-media').dataset.speed);
      // console.log("number_seconds:",number_seconds);
      if(number_seconds > 0){
        if(isInViewport(section) && first_anmation){
          let blocks = section.querySelectorAll('.image-link-blocks__item');
          blocks.forEach(block => {
            block.querySelector('.product-card__figure').classList.add("hovering_effect");
          });
          setTimeout(() => {
            let blocks = section.querySelectorAll('.image-link-blocks__item');
            blocks.forEach(block => {
              block.querySelector('.product-card__figure').classList.remove("hovering_effect");
            });
          }, (number_seconds*1000));
          first_anmation = false;
        }
      }
    }
  });
}

function imageLinkBlocksSectionBehaviour(){
  let image_link_blocks = document.querySelectorAll(".shopify-section--image-link-blocks");
  if( image_link_blocks.length > 0 && window.innerWidth <= 699){
    document.addEventListener("scroll", () => {
      secondaryImageMobile(image_link_blocks);
    });
  }
}

function imageBannerAnimation(animationSections){
  animationSections.forEach(section => {
    if(section.querySelector('.banner_second_animation')){
      let number_seconds = parseInt(section.querySelector('.section').dataset.speed);
      if(number_seconds > 0){
        if(section.classList.contains("banner_viewport_effect") && !isInViewport(section)){
          section.classList.remove("banner_viewport_effect");
        }
        if(isInViewport(section)){
          setTimeout(() => {
            // console.log("isInViewport(section):",isInViewport(section));
              section.classList.add("banner_viewport_effect");
          }, (number_seconds*1000));
        }
      }
    }
  });
}

function imagesAnimationSectionBehaviour(){
  let images_animation_sections = document.querySelectorAll(".image-animation-section");
  if( images_animation_sections.length > 0 ){
    imageBannerAnimation(images_animation_sections);
    document.addEventListener("scroll", () => {
      imageBannerAnimation(images_animation_sections);
    });
  }
}

document.addEventListener('DOMContentLoaded', function(){
  imageLinkBlocksSectionBehaviour();
  document.addEventListener("resize", () => {
    imageLinkBlocksSectionBehaviour();
  });
  imagesAnimationSectionBehaviour();
});

// Added the code so we can also change the language when the market switches
// https://shopify.dev/docs/storefronts/themes/markets/multiple-currencies-languages
 class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.querySelector('.change_language').setAttribute('value',event.currentTarget.dataset.lang);
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

// Play/Stop Function For Marquee-Text
function adjustMarqueeStartPause(marqueeContainers){
  marqueeContainers.forEach(container => {
    // Select the start and pause buttons
    let startButton = container.querySelector(".start_scrolling"),
        pauseButton = container.querySelector(".pause_scrolling"),
        // Select the marquee text elements
        marqueeTexts = container.querySelectorAll("marquee-text span");
    // Add event listeners to the start and pause buttons to toggle the marquee text and button states
    startButton.addEventListener("click", event => {
      toggleMarquee(marqueeTexts, startButton, pauseButton);
    });
    pauseButton.addEventListener("click", event => {
      toggleMarquee(marqueeTexts, startButton, pauseButton);
    });
  });
}
function toggleMarquee(marqueeTexts, startButton, pauseButton) {
  // Toggle the pause class on the marquee text elements
  marqueeTexts.forEach(text => {
    text.classList.toggle("pause_scrolling");
  });
  // Toggle the hidden class on the start and pause buttons
  startButton.classList.toggle("hidden");
  pauseButton.classList.toggle("hidden");
}

// Play/Pause of video controls
class CustomVideoControls {
  constructor() {
    this.init();
  }

  init() {
    const videoButtons = document.querySelectorAll('.scrolling_video_btns');
    if (!videoButtons.length) return;

    videoButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleClick(e, button));
    });
  }

  handleClick(event, button) {
    const playBtn = button.querySelector('.start_playing');
    const pauseBtn = button.querySelector('.pause_playing');
    const videoContainer = button.closest('video-media');
    const slideshowContainer = button.closest('slideshow-carousel');

    // Handle single video
    if (videoContainer) {
      this.toggleVideo(videoContainer, event);
    }

    // Handle slideshow videos
    if (slideshowContainer) {
      const selectedSlide = slideshowContainer.querySelector('.slideshow__slide.is-selected');
      if (selectedSlide) {
        selectedSlide.querySelectorAll('video-media').forEach(container => {
          this.toggleVideo(container, event);
        });
      }
    }

    // Toggle button visibility
    if (playBtn && pauseBtn) {
      playBtn.classList.toggle('hidden');
      pauseBtn.classList.toggle('hidden');
    }
  }

  toggleVideo(container, event) {
    const video = container.querySelector('video');
    if (!video) return;

    const isPause = event.target.closest('.pause_playing');
    const isPlay = event.target.closest('.start_playing');

    try {
      if (isPause) {
        video.pause();
      } else if (isPlay) {
        video.play().catch(err => console.error('Play failed:', err));
      }
    } catch (error) {
      console.error('Video control error:', error);
    }
  }
}

window.addEventListener("load", function(){
  let marqueeContainers = document.querySelectorAll(".scrolling_marquee");
  if(marqueeContainers.length > 0){
    // Adjust the start and pause buttons for the marquee containers
    adjustMarqueeStartPause(marqueeContainers);
  }
  new CustomVideoControls();
});